import { NgModule, ModuleWithProviders, Optional, SkipSelf } from '@angular/core';
import { WipService } from './shared/services/wip.service';
import { FinanceLookupService} from './shared/services/finance-lookup.service';
import { FinanceService } from './shared/services/finance.service';

import { EndOfDayService } from './services/endofday.service'; // ONLY NEED TEMPORARILY TO USE THE BALANCE AND ISSUE NEW CASH DRAWER FEATURE ON THE MAIN FINANCE PAGE

@NgModule()
export class FinanceCoreModule {

    constructor( @Optional() @SkipSelf() parentModule: FinanceCoreModule) {
        if (parentModule) {
            throw new Error(
                'FinanceCoreModule is already loaded. Import it in the AppModule only');
        }
    }

    static forRoot(): ModuleWithProviders<FinanceCoreModule> {
        return {
            ngModule: FinanceCoreModule,
            providers: [
                WipService,
                FinanceLookupService,
                FinanceService,
                EndOfDayService

            ]
        };
    }
}
